import { useRef, useState, useEffect } from 'react';
import { senpais } from '../data/content';
import SenpaiCard from './SenpaiCard';
import './Senpais.css';

export default function Senpais() {
  const trackRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateArrows = () => {
    const el = trackRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 4);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  };

  useEffect(() => {
    updateArrows();
    const el = trackRef.current;
    el?.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    return () => {
      el?.removeEventListener('scroll', updateArrows);
      window.removeEventListener('resize', updateArrows);
    };
  }, []);

  const scroll = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector('.senpai-card');
    const step = card ? card.offsetWidth + 22 : 300;
    el.scrollBy({ left: dir === 'left' ? -step : step, behavior: 'smooth' });
  };

  const showArrows = senpais.length > 4;

  return (
    <section id="senpais" className="senpais">
      <div className="senpais__header">
        <div className="senpais__eyebrow">
          <span className="senpais__rule" />
          <span>Nuestros Instructores</span>
          <span className="senpais__rule" />
        </div>
        <h2 className="senpais__title">
          LOS <span className="text-red">SENPAIS</span>
        </h2>
        <div className="senpais__jp">先輩</div>
      </div>

      <div className="senpais__track-wrapper">
        {showArrows && canScrollLeft && (
          <button className="senpais__arrow senpais__arrow--left" onClick={() => scroll('left')}>&lsaquo;</button>
        )}
        <div className="senpais__track" ref={trackRef}>
          {senpais.map((senpai) => (
            <SenpaiCard key={senpai.name} senpai={senpai} />
          ))}
        </div>
        {showArrows && canScrollRight && (
          <button className="senpais__arrow senpais__arrow--right" onClick={() => scroll('right')}>&rsaquo;</button>
        )}
      </div>
    </section>
  );
}